
export const STORAGE_KEYS = {
  PASSWORD_HASH: 'nalc_auth_password',
  AUTH_SESSION: 'nalc_auth_session',
  LOCKOUT_INFO: 'nalc_auth_lockout',
  SECURE_PASSKEY: 'nalc_secure_passkey'
};

export interface PasswordStrength {
  isValid: boolean;
  message: string;
}

export interface PasswordContextType {
  // Status flags
  isProtected: boolean;
  isLocked: boolean;
  accessGranted: boolean;
  hasPassword: boolean;
  attemptsRemaining: number;
  remainingAttempts: number;
  lockoutEndTime: Date | null;
  
  // Methods
  verifyPassword: (password: string) => boolean;
  verifyPasskey: (passkey: string) => boolean;
  changePassword: (currentPassword: string, newPassword: string) => boolean;
  changePasskey: (password: string, newPasskey: string) => boolean;
  resetPassword: (currentPassword: string | null, newPassword: string) => boolean;
  setupInitialAuth: (password: string, passkey?: string) => boolean;
  resetFailedAttempts: () => void;
  lockApplication: () => void;
  unlockApplication: () => boolean;
  hasPasswordSet: () => boolean;
  createPassword: (password: string) => void;
  clearPassword: () => void;
  passwordStrength: (password: string) => PasswordStrength;
  verifySecurePassKey: (passkey: string) => boolean;
  hasSecurePassKey: () => boolean;
  clearAuthSession: () => void;
  lockAccount: () => void;
}
